import React from 'react'
import { Box, Typography } from '@mui/material'
import errorIcon from "../../../../assets/icons/ic-solar_danger-bold.svg"
import warningIcon from "../../../../assets/icons/ic-solar_danger-triangle-bold.svg"
import info from "../../../../assets/icons/alert-circle.svg"


const variantConfig = {
    warning: {
        bg: '#FFF5CC',
        color: '#7A4100',
        icon: <img src={warningIcon} alt='warning-icon' />
    },
    info: {
         bg: '#FFF5CC',
        color: '#7A4100',
        icon: <img src={info} alt='warning-icon' />
    },

    error: {
        bg: '#FFE9D5',
        color: '#7A0916',
        icon: <img src={errorIcon} alt='error-icon' />
    },
};

const AlertMessage = ({ type = "warning", title, message, highlight }) => {
    const config = variantConfig[type] || variantConfig?.warning;

    return (
        <Box
            sx={{
                backgroundColor: config?.bg,
                borderRadius: '8px',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1.5
            }}
        >
            {/* Icon */}
            {config?.icon}

            {/* Texts */}
            <Box>
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: config?.color }}>
                    {title}
                </Typography>
                {message ? (
                    <Typography sx={{ fontSize: '12px', color: config?.color }}>
                        {message?.split(highlight)[0]}
                        <Box component="span" sx={{ fontWeight: 600 }}>
                            {highlight}
                        </Box>
                        {message?.split(highlight)[1]}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    )
}

export default AlertMessage